import React, { Component, Fragment } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Link } from "react-router-dom";
import { Button, Pane, Portal, Popover, Menu } from "evergreen-ui";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { AuthConsumer } from "contexts/auth";
import LoginForm from "components/LoginForm/LoginForm";
import Logout from "components/Logout/Logout";
import Sitelogo from "components/Sitelogo/Sitelogo";
import Navigation from "components/Navigation/Navigation";
import MobileNavigation from "components/MobileNavigation/MobileNavigation";
import HamburgerMenu from "assets/images/menu.svg";
import { API, Auth } from "aws-amplify";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogin: false,
      showMobileNav: false,
      isLoading: false,
    };
  }

  toggleMobileNav = () => {
    this.setState({
      showMobileNav: !this.state.showMobileNav,
    });
  };

  toggleLoginForm = () => {
    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  handleDownloadCases = async (event) => {
    event.preventDefault();
    const jwtToken = await Auth.currentSession();
    this.setState({
      isLoading: true,
    });
    try {
      await API.get("parvoalert", "/csv/all", {
        headers: { Authorization: `Bearer ${jwtToken.idToken.jwtToken}` },
      })
        .then((res) => {
          window.location.href = res.s3url;
        })
        .catch((err) => console.log({ err }));
      this.setState({ isLoading: false });
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  handleDownloadOrganisations = async (event) => {
    event.preventDefault();
    const jwtToken = await Auth.currentSession();
    this.setState({
      isLoading: true,
    });
    try {
      await API.get("parvoalert", "/organizations/download", {
        headers: { Authorization: `Bearer ${jwtToken.idToken.jwtToken}` },
      })
        .then((res) => {
          window.location.href = res.s3url;
        })
        .catch((err) => console.log({ err }));
      this.setState({ isLoading: false });
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  handleDownloadUsers = async (event) => {
    event.preventDefault();
    const jwtToken = await Auth.currentSession();
    this.setState({
      isLoading: true,
    });
    try {
      await API.get("parvoalert", "/users/download", {
        headers: { Authorization: `Bearer ${jwtToken.idToken.jwtToken}` },
      })
        .then((res) => {
          window.location.href = res.s3url;
        })
        .catch((err) => console.log({ err }));
      this.setState({ isLoading: false });
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const loginClass = classNames({
      "hidden-xs": !this.state.showLogin,
    });

    const mobileNavClass = classNames({
      "mobile-navigation": true,
      "hidden-xs": !this.state.showMobileNav,
      "hidden-md": true,
      "hidden-lg": true,
      "hidden-sm": true,
      "hidden-xl": true,
    });
 console.log('Build Test')
    return (
      <header>
        <AuthConsumer>
          {({ isAdmin }) => (
            <Fragment>
              {isAdmin && (
                <Portal>
                  <Pane
                    background="#000"
                    padding={16}
                    position="fixed"
                    bottom={0}
                    padding={0}
                  >
                    <ul className="admin-links">
                      <li>Admin Options:</li>
                      <li>
                        <Popover
                          content={
                            <Menu id="menuPopup" className="menuPopup">
                              <Menu.Item
                                is={Link}
                                to="/admin/cases"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                View / Edit Cases
                              </Menu.Item>
                              <Menu.Item
                                onClick={this.handleDownloadCases}
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Download Cases
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Button>Manage Cases</Button>
                        </Popover>
                        {/* <Link to='/admin/cases'>Manage Cases</Link> */}
                      </li>
                      <li>
                        <Popover
                          style={{ backgroundColor: "#000" }}
                          content={
                            <Menu>
                              <Menu.Item
                                is={Link}
                                to="/admin/users"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                View / Edit Users
                              </Menu.Item>
                              <Menu.Item
                                is={Link}
                                to="/admin/groups"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Pending Users
                              </Menu.Item>
                              <Menu.Item
                                onClick={this.handleDownloadUsers}
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Download Users
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Button>Manage Users</Button>
                        </Popover>
                      </li>
                      <li>
                        <Popover
                          style={{ backgroundColor: "#000" }}
                          content={
                            <Menu>
                              <Menu.Item
                                is={Link}
                                to="/admin/organisations/"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                View / Edit Organisations
                              </Menu.Item>
                              <Menu.Item
                                is={Link}
                                to="/admin/pending-organisations"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Pending Organisations
                              </Menu.Item>
                              <Menu.Item
                                is={Link}
                                to="/admin/merge-organisations"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Merge Organisations
                              </Menu.Item>

                              <Menu.Item
                                onClick={this.handleDownloadOrganisations}
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Download Organisations
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Button>Manage Organisations</Button>
                        </Popover>
                      </li>
                      <li>
                        <Popover
                          style={{ backgroundColor: "#000" }}
                          content={
                            <Menu> 
                               <Menu.Item
                                is={Link}
                                to="/admin/create-media-release"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Create Media Release
                              </Menu.Item>
                              <Menu.Item
                                is={Link}
                                to="/admin/media-release"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                View / Edit Media Release
                              </Menu.Item>
                              <Menu.Item
                                is={Link}
                                to="/admin/update-media"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#000",
                                }}
                              >
                                Update Media Info
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Button>Manage Media</Button>
                        </Popover>
                      </li>
                    </ul>
                  </Pane>
                </Portal>
              )}
            </Fragment>
          )}
        </AuthConsumer>
        <Grid className="site-header">
          <div className="hidden-md hidden-sm hidden-lg hidden-xl mobile-header">
            <AuthConsumer>
              {({ isAuthenticated }) => (
                <Fragment>
                  {isAuthenticated ? (
                    <Button
                      iconBefore="user"
                      marginTop={10}
                      height={24}
                      onClick={this.toggleLoginForm}
                    >
                      Account
                    </Button>
                  ) : (
                    <Button
                      marginTop={10}
                      height={24}
                      onClick={this.toggleLoginForm}
                    >
                      Sign In
                    </Button>
                  )}
                </Fragment>
              )}
            </AuthConsumer>
            <img
              alt="Menu"
              onClick={this.toggleMobileNav}
              src={HamburgerMenu}
              className="hamburgermenu"
            />
          </div>
          <Row>
            <Col md={8}>
              <Sitelogo />
            </Col>
            <Col md={4} className={loginClass}>
              <AuthConsumer>
                {({ isAuthenticated, isAdmin }) => (
                  <div>
                    {isAuthenticated ? (
                      <Pane display="flex" paddingTop={16}>
                        <Link to="/account">
                          <Button iconBefore="user">My Account</Button>
                        </Link>
                        <Logout />
                      </Pane>
                    ) : (
                      <LoginForm />
                    )}
                  </div>
                )}
              </AuthConsumer>
            </Col>
          </Row>
        </Grid>
        <div className={mobileNavClass}>
          <MobileNavigation handleClick={this.toggleMobileNav} />
        </div>
        <div className="site-navigation hidden-xs">
          <Grid>
            <Row>
              <Col md={12}>
                <Navigation />
              </Col>
            </Row>
          </Grid>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
